import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=2ab51da9"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=2ab51da9&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab51da9')) {
      api.createRecord('2ab51da9', component.options)
    } else {
      api.reload('2ab51da9', component.options)
    }
    module.hot.accept("./Layout.vue?vue&type=template&id=2ab51da9", function () {
      api.rerender('2ab51da9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Layout.vue"
export default component.exports